import { render } from "./UITableNav.vue?vue&type=template&id=0d619491&scoped=true&ts=true"
import script from "./UITableNav.vue?vue&type=script&lang=ts"
export * from "./UITableNav.vue?vue&type=script&lang=ts"

import "./UITableNav.vue?vue&type=style&index=0&id=0d619491&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d619491"]])

export default __exports__